export default __webpack_public_path__ + "static/media/img_job_02.477d8d30.jpg";